import React from "react";
import { Container } from "../../components/container";

function Connections() {
  return (
    <section
      className="bg-[#EAEAEA]"
      id="connections"
      aria-label="Connections and community"
    >
      <Container>
        <div className="flex flex-col lg:flex-row gap-20">
          <div className="flex flex-col items-start justify-center">
            <h2 className="font-ppacma text-[56px] md:text-8xl leading-[90%] mt-6 lg:max-w-[760px] break-words">
              <span className="text-black">Connections &</span>{" "}
              <span className="text-yellow">Community</span>
            </h2>

            <p className="text-black text-[18px] font-normal leading-[120%] tracking-[0px] lg:max-w-[462px] mt-6">
              Your inside track to every city your team calls home. League Life
              brings together trusted local insights, team-specific details, and
              the connections, whether you're arriving for the season or just in
              town for a weekend.
            </p>
          </div>
          <div className="flex justify-center lg:justify-start">
            <img
              src="/connections/phone.png"
              alt="League Life app showing community connections and local insights"
              width={366}
              height="auto"
              loading="lazy"
            />
          </div>
        </div>
      </Container>
    </section>
  );
}

export { Connections };
